import { QueryClient } from '@tanstack/react-query';
import { LoaderFunctionArgs, redirect } from 'react-router';
import {
  isStaffPermissionEnabled,
  staffQueryFn,
  staffQueryKey,
} from '~/hooks/queries/useStaffQuery/useStaffQuery';
import { perms } from './perms';
import { requirePerm } from './requirePerm';

/** Staff /staff/ops/* routes — Dianomi login plus `permissions.admin` from staff.pl. */
export const staffAdminPermsLoader = (queryClient: QueryClient) => {
  return async (args: LoaderFunctionArgs) => {
    await requirePerm(perms.isDianomi)(args);
    const staffData = await queryClient.ensureQueryData({
      queryKey: staffQueryKey,
      queryFn: staffQueryFn,
    });
    if (!isStaffPermissionEnabled(staffData.permissions.admin)) {
      throw redirect('/forbidden');
    }
    return staffData;
  };
};
